import chain from '@/lib/axios-chain'

// 添加大屏时候预置数据
export const getAllConfig = () => chain.create('/config/tv/getAllConfig', 'get')

// 当前大屏配置详情
export const getConfig = () => chain.create('/config/tv/getConfig', 'get')

// 获取大屏列表
export const getList = () => chain.create('/config/tv/index', 'get')

// 保存添加/修改大屏配置
export const setConfig = () => chain.create('/config/tv/setConfig', 'post')

// 授权码生成
export const setCode = () => chain.create('/config/tv/setCode', 'get')

// 删除当前大屏
export const delConfig = () => chain.create('/config/tv/delConfig', 'post')

// 停用当前大屏
export const closeConfig = () => chain.create('/config/tv/closeConfig', 'post')

// 启用当前大屏
export const openConfig = () => chain.create('/config/tv/openConfig', 'post')

// 获取组合列表
export const getTvGroupList = () => chain.create('/config/tv/list', 'get')

// 当前组合配置详情
export const getMergeConfig = () => chain.create('/config/tv/getMergeConfig', 'get')

// 添加/编辑组合
export const setMergeConfig = () => chain.create('/config/tv/setMergeData', 'post')

// 获取大屏可选下拉 编辑组合使用
export const getTvSelect = () => chain.create('/config/tv/tvSelect', 'get')

// 大屏\组合名称是否重复
export const checkRepeat = () => chain.create('/config/tv/checkRepeat', 'get')

// 根据角色或用户id或分组id获取全部用户的信息
export const getAllUselList = () => chain.create('/config/tv/getAllUserList', 'post')
